import React, { Component } from 'react';
import './App.css';

import PropTypes, { bool } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField'
import Button from "@material-ui/core/Button";
import _ from 'lodash';
import { withSnackbar } from 'notistack';
import qs from "qs";
import FormGroup from "@material-ui/core/FormGroup";
import axios from "axios";
import ModalPopup from './ModalPopup';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import {urlConfig} from './config'


const styles = theme => ({
    container: {
        position: 'relative',
    },
});


class VideoReplacement extends Component {

    constructor(props) {
        super(props);
        let parsed = qs.parse(this.props.location.search);

        let cid = "";
        let sourceUrl = "";


        if (parsed["cid"] && parsed["cid"].length > 0) {
            cid = parsed["cid"];
        }

        if (parsed["?sourceUrl"] && parsed["?sourceUrl"].length > 0) {
            sourceUrl = parsed["?sourceUrl"];
        }

        this.state = {
            cid: cid, sourceUrl: sourceUrl, responseData: null, isloading: false, isError: false, show: false, urlError: false
        };
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };


    videoReplacement = async (event) => {
        try {
            event.preventDefault();
            this.setState({
                isloading: true,
                isError: false,
                show: false
            })
            const { cid, sourceUrl } = this.state
            const { data } = await axios.post(`${urlConfig.cmsURL}/api/VideoReplacement`, {
                sourceUrl,
                cid,
                userEmail:sessionStorage.getItem("userEmail")
            })

            this.setState({
                responseData: data,
                isloading: false,
                sourceUrl:'',
                cid:''
            })

        } catch (error) {
            this.setState({
                isloading: false,
                isError: true
            })
        }



    }


    render() {
        const { responseData, isloading, sourceUrl, cid, isError, show, urlError } = this.state
        const { classes, theme } = this.props
        const Loader = () => {
            return (<div className='loader-wrapper'>
                <div class="loader"></div>
                <p>Processing...</p>
            </div>)
        }

        const onClickPopupClose = () => {
            this.setState({ show: false })
        }

        const onClickPopupOpen = (e) => {
            e.preventDefault()
            var mailformat = /^(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9_ @:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9_ @:%_\+.~#?&\/\/=]*)$/
            console.log(sourceUrl.match(mailformat))
            if ((!(sourceUrl.match(mailformat)))) {
                this.setState({
                    urlError: true
                });
            return
            }
            this.setState({ show: true ,urlError: false})
        }
        return <React.Fragment>
            <Paper>
                <React.Fragment>
                    <Grid spacing={0}
                        container
                        direction="row"
                        justify="flex-start"
                        alignItems="center">
                        <Grid item xs={1}></Grid>
                        <Grid item xs={10}>
                            <form onSubmit={onClickPopupOpen}>
                                <FormGroup row>
                                    <Grid spacing={2}
                                        container
                                        direction="row"
                                        justify="flex-start"
                                        alignItems="center">
                                        <Grid item xs={8}>
                                            <TextField
                                                id="outlined-url"
                                                label="Source URL"
                                                onChange={this.handleChange}
                                                margin="normal"
                                                fullWidth
                                                multiline={true}
                                                rows={3}
                                                name="sourceUrl"
                                                value={sourceUrl}
                                                variant="outlined"
                                                required={true}
                                            />
                                             {urlError &&
                                            <p style={{ color: "red", fontSize: "1rem" }}>Please enter valid URL</p>
                                        }
                                        </Grid>
                                       
                                        <Grid item xs={2}>
                                            <TextField
                                                id="outlined-cid"
                                                label="CID"
                                                onChange={this.handleChange}
                                                margin="normal"
                                                variant="outlined"
                                                fullWidth
                                                value={cid}
                                                required={true}
                                                name="cid"
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Button disabled={isloading} variant="contained" color="primary" type="submit"
                                                size={"large"} className={classes.button}>
                                                submit
                                            </Button>
                                        </Grid>

                                        {show && <ModalPopup show={this.state.show} close={onClickPopupClose} submit={this.videoReplacement} />}


                                    </Grid>
                                </FormGroup>
                            </form>
                            <ModalPopup />
                            <style jsx>
                                {`
                                .loader {
                                    border:8px solid #f3f3f3; /* Light grey */
                                border-top: 8px solid #ffbf00; /* Blue */
                                border-radius: 50%;
                                width: 50px;
                                height: 50px;
                                animation: spin 2s linear infinite;
                                }
                               .loader-wrapper{
                                display:flex;
                                justify-content:center;
                                align-items: center;
                                flex-direction: column;
                                margin-top:1rem;
                                }

                                @keyframes spin {
                                    0 % { transform: rotate(0deg); }
                                    100% {transform: rotate(360deg); }
                                }`}
                            </style>
                            {isloading ? <Loader /> :

                                <>{isError ? <p style={{ color: "red", fontSize: "1rem" }}>something went wrong please connect with CMS team </p> : (responseData && !urlError && !show) &&<p style={{ fontSize: "1rem", fontWeight:"bold" }}>Request has been Successfully Submitted</p>}</>
                            }
                            <br />

                        </Grid>
                    </Grid>
                </React.Fragment>
            </Paper>

        </React.Fragment>
    }
}


VideoReplacement.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


export default withSnackbar((withStyles(styles, { withTheme: true })(VideoReplacement)));
